import messageResource from '../../../messageResource'
import {BillingSummaryReportInfo, TimeApprovalStatus} from 'constants'

export default function CSVParametersBuilder() {}

CSVParametersBuilder.prototype.init = function()
{
    this.parameters = [];
    return this;
};

CSVParametersBuilder.prototype.addDateRangeParam = function( dateRangeSelection, reportParamsStringBuilder )
{
    this.parameters.push( [messageResource.getMessage("report.date_range_label"), reportParamsStringBuilder.getDateRangeCSVString(dateRangeSelection) ] );
};

CSVParametersBuilder.prototype.addCPParam = function( customersProjectsSelection, reportParamsStringBuilder )
{
    this.parameters.push( [messageResource.getMessage("report.customers_projects_label"), reportParamsStringBuilder.getCPSelectionParamString( customersProjectsSelection )] )
};

CSVParametersBuilder.prototype.addUsersParam = function( userSelection, reportParamsStringBuilder, assignedInfo )
{
    this.parameters.push( [messageResource.getMessage("report.staff_label"), reportParamsStringBuilder.getUserSelectionParamString(userSelection, assignedInfo)] )
};

CSVParametersBuilder.prototype.addOvertimeUsersParam = function( userSelection, reportParamsStringBuilder )
{
    this.parameters.push( [messageResource.getMessage("report.staff_label"), reportParamsStringBuilder.getUserSelectionParamString(userSelection)] )
};

CSVParametersBuilder.prototype.addTimeTrackStatusParam = function( timeTrackStatus )
{
    let textStatus
    switch( timeTrackStatus )
    {
        case TimeApprovalStatus.APPROVED: textStatus = messageResource.getMessage("report.form.show_only_approved"); break;
        case TimeApprovalStatus.NOT_APPROVED: textStatus = messageResource.getMessage("report.form.show_only_not_approved"); break;
        default: textStatus = messageResource.getMessage("report.form.show_both_approved_and_not");
    }
    this.parameters.push( [messageResource.getMessage("report.time_track_status") + ":", textStatus ] );
};

CSVParametersBuilder.prototype.addBillingSummaryReportTypeParam = function( reportType )
{
    let reportTypeMsgKey = reportType === BillingReportType.ALL_TIME_WITHIN_DATE_RANGE ?
                           "report.billing_summary.time_for_date_range" : "report.billing_summary.time_task_completed_for_date_range";
    this.parameters.push( [messageResource.getMessage("report.billing_summary.report_type_label"), messageResource.getMessage( reportTypeMsgKey )] );
};

CSVParametersBuilder.prototype.addBillingSummaryTasksParam = function( reportInfo )
{
    let reportInfoMsgKey = ""
    if ( reportInfo === BillingSummaryReportInfo.TIME_ON_NON_BILLABLE_TASKS )
        reportInfoMsgKey = "report.billing_summary.non_billable_only";
    else if ( reportInfo === BillingSummaryReportInfo.TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS )
        reportInfoMsgKey = "report.billing_summary.billable_nonbillable";
    else
        reportInfoMsgKey = "report.billing_summary.billable_only";
    this.parameters.push( [messageResource.getMessage("common.Tasks") + ":", messageResource.getMessage( reportInfoMsgKey )] );
};

CSVParametersBuilder.prototype.addLeavesParam = function( leaveTypesSelection, reportParamsStringBuilder )
{
    this.parameters.push( [messageResource.getMessage("report.leave_types.label"), reportParamsStringBuilder.getLeaveTypeSelectionParamString(leaveTypesSelection) ] );
};

CSVParametersBuilder.prototype.addEvATasksParam = function( taskParams, dateSelection, reportParamsStringBuilder )
{
    this.parameters.push( [messageResource.getMessage("report.budgeted_vs_actual.tasks"), reportParamsStringBuilder.getEvATaskDetailsString(taskParams, dateSelection) ] );
};

CSVParametersBuilder.prototype.getParameters = function()
{
    return this.parameters;
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/CSVParametersBuilder.js